import React from 'react';
import PropTypes from 'prop-types';
import { Box, styled } from '@ublend-npm/aulaui-core';
import ConversationModalParticipants from '../ConversationModal/ConversationModalParticipants.container';

const GroupAvatarContainer = styled('div')`
  display: flex;
  justify-content: start;
  height: 40px;
  width: 40px;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 16px;
  padding-right: 16px;
`;

const GroupAvatarIndicator = ({
  conversation,
  currentUser,
  openViewParticipants,
}) => {
  // Show for both group and individual conversations to match the screenshot
  if (!conversation) {
    return null;
  }

  return (
    <GroupAvatarContainer data-testid="group-avatar-indicator">
      <Box>
        <ConversationModalParticipants
          conversation={conversation}
          currentUser={currentUser}
          openViewParticipants={openViewParticipants}
        />
      </Box>
    </GroupAvatarContainer>
  );
};

GroupAvatarIndicator.propTypes = {
  conversation: PropTypes.object,
  currentUser: PropTypes.object,
  openViewParticipants: PropTypes.func,
};

GroupAvatarIndicator.defaultProps = {
  conversation: null,
  currentUser: null,
  openViewParticipants: () => {},
};

export default GroupAvatarIndicator;
